<div class="card">
  <div class="card-header">
    <h5 class="card-title">Statement of Responsibilities</h5>
    <h6 class="card-subtitle text-body-secondary">UK</h6>
  </div>
  <div class="card-body">
    @if (hasLastYearData) {
      <ad-alert-data-preloaded />
    }
    <form [formGroup]="form">
      <!-- 1. Personal Particulars -->
      <div class="card mb-3">
        <div class="card-header">
          <h5 class="card-title mb-0">1. Personal Particulars</h5>
        </div>
        <div class="card-body">
          <p>Name: {{ user?.name }}</p>
          <p>Title: {{ user?.title }}</p>
          <ejs-textbox class="w-25" placeholder="IRN" formControlName="irn"></ejs-textbox>
          <small class="form-text text-muted">If applicable</small>
        </div>
      </div>

      <!-- 2. Senior Management Functions -->
      <div class="card mb-3">
        <div class="card-header">
          <h5 class="card-title mb-0">2. Senior Management Functions</h5>
        </div>
        <div class="card-body">
          <table formArrayName="seniorManagementFunctions" class="table">
            <thead>
              <tr>
                <th class="ps-3">Function</th>
                <th class="w-50">Description</th>
                <th>Type of Firm</th>
                <th>Effective Date</th>
                @if (!alreadySubmitted) {
                  <th></th>
                }
              </tr>
            </thead>
            <tbody>
              @for (
                seniorManagementFunction of seniorManagementFunctions.controls;
                track seniorManagementFunction;
                let i = $index
              ) {
                <tr [formGroup]="getAsFormGroup(seniorManagementFunction)">
                  <td class="align-middle ps-3">
                    <ejs-textbox formControlName="function" placeholder="Function"></ejs-textbox>
                    @if (seniorManagementFunction.get('function')?.hasError('required')) {
                      <small class="text-danger d-block">Function is required</small>
                    }
                  </td>
                  <td class="align-middle">
                    <ejs-textbox
                      formControlName="description"
                      placeholder="Description"
                      [multiline]="true"
                      floatLabelType="Auto"
                    />
                    @if (seniorManagementFunction.get('description')?.hasError('required')) {
                      <small class="text-danger d-block">Description is required</small>
                    }
                  </td>
                  <td class="align-middle">
                    <ejs-textbox formControlName="typeOfFirm" placeholder="Type of Firm"></ejs-textbox>
                    @if (seniorManagementFunction.get('typeOfFirm')?.hasError('required')) {
                      <small class="text-danger d-block">Type of firm is required</small>
                    }
                  </td>
                  <td class="align-middle">
                    <ejs-datepicker formControlName="effectiveDate" placeholder="DD/MM/YYYY"></ejs-datepicker>
                    @if (seniorManagementFunction.get('effectiveDate')?.hasError('required')) {
                      <small class="text-danger d-block">Effective date is required</small>
                    }
                  </td>
                  @if (!alreadySubmitted) {
                    <td class="align-middle">
                      <button class="btn btn-sm btn-danger" (click)="removeSeniorManagementFunction(i)" title="Remove">
                        <span class="material-icons">delete</span>
                      </button>
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
        @if (!alreadySubmitted) {
          <div class="card-footer">
            <button
              class="btn btn-sm btn-primary"
              (click)="addSeniorManagementFunction()"
              title="Add senior management function"
            >
              <span class="material-icons">add</span>
            </button>
          </div>
        }
      </div>

      <!-- 3. Prescribed Responsibilities -->
      <div class="card mb-3">
        <div class="card-header">
          <h5 class="card-title mb-0">3. Prescribed Responsibilities</h5>
        </div>
        <div class="card-body">
          <table formArrayName="prescribedResponsibilities" class="table">
            <thead>
              <tr>
                <th class="ps-3">FCA Ref</th>
                <th class="w-50">Prescribed Responsibility</th>
                <th>Shared</th>
                <th>Justification if shared</th>
                @if (!alreadySubmitted) {
                  <th></th>
                }
              </tr>
            </thead>
            <tbody>
              @for (responsibility of prescribedResponsibilities.controls; track responsibility; let i = $index) {
                <tr [formGroup]="getAsFormGroup(responsibility)">
                  <td class="align-middle ps-3">
                    <ejs-textbox formControlName="fcaRef" placeholder="FCA Ref"></ejs-textbox>
                    @if (responsibility.get('fcaRef')?.hasError('required')) {
                      <small class="text-danger d-block">FCA Ref is required</small>
                    }
                  </td>
                  <td class="align-middle">
                    <ejs-textbox
                      formControlName="responsibility"
                      placeholder="Prescribed Responsibility"
                      [multiline]="true"
                      floatLabelType="Auto"
                    />
                    @if (responsibility.get('responsibility')?.hasError('required')) {
                      <small class="text-danger d-block">Responsibility is required</small>
                    }
                  </td>
                  <td class="align-middle">
                    <ejs-switch formControlName="isShared" onLabel="YES" offLabel="NO" />
                  </td>
                  <td class="align-middle">
                    <ejs-textbox
                      formControlName="sharedJustification"
                      placeholder="Justification if shared"
                      [multiline]="true"
                      floatLabelType="Auto"
                    />
                    @if (responsibility.get('sharedJustification')?.hasError('required')) {
                      <small class="text-danger d-block">Shared justification is required</small>
                    }
                  </td>
                  @if (!alreadySubmitted) {
                    <td class="align-middle">
                      <button class="btn btn-sm btn-danger" (click)="removePrescribedResponsibility(i)" title="Remove">
                        <span class="material-icons">delete</span>
                      </button>
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
        @if (!alreadySubmitted) {
          <div class="card-footer">
            <button
              class="btn btn-sm btn-primary"
              (click)="addPrescribedResponsibility()"
              title="Add prescribed responsibility"
            >
              <span class="material-icons">add</span>
            </button>
          </div>
        }
      </div>

      <!-- 4. Other Responsibilities -->
      <div class="card mb-3">
        <div class="card-header">
          <h5 class="card-title mb-0">4. Other Responsibilities</h5>
        </div>
        <div class="card-body">
          <table formArrayName="otherResponsibilities" class="table">
            <thead>
              <tr>
                <th class="ps-3">Title</th>
                <th class="w-50">Details</th>
                <th>Shared</th>
                <th>Justification if shared</th>
                @if (!alreadySubmitted) {
                  <th></th>
                }
              </tr>
            </thead>
            <tbody>
              @for (responsibility of otherResponsibilities.controls; track responsibility; let i = $index) {
                <tr [formGroup]="getAsFormGroup(responsibility)">
                  <td class="align-middle ps-3">
                    <ejs-textbox formControlName="title" placeholder="Title"></ejs-textbox>
                    @if (responsibility.get('title')?.hasError('required')) {
                      <small class="text-danger d-block">Title is required</small>
                    }
                  </td>
                  <td class="align-middle">
                    <ejs-textbox
                      formControlName="details"
                      placeholder="Details"
                      [multiline]="true"
                      floatLabelType="Auto"
                    />
                    @if (responsibility.get('details')?.hasError('required')) {
                      <small class="text-danger d-block">Details are required</small>
                    }
                  </td>
                  <td class="align-middle">
                    <ejs-switch formControlName="isShared" onLabel="YES" offLabel="NO" />
                  </td>
                  <td class="align-middle">
                    <ejs-textbox
                      formControlName="sharedJustification"
                      placeholder="Justification if shared"
                      [multiline]="true"
                      floatLabelType="Auto"
                    />
                    @if (responsibility.get('sharedJustification')?.hasError('required')) {
                      <small class="text-danger d-block">Shared justification is required</small>
                    }
                  </td>
                  @if (!alreadySubmitted) {
                    <td class="align-middle">
                      <button class="btn btn-sm btn-danger" (click)="removeOtherResponsibility(i)" title="Remove">
                        <span class="material-icons">delete</span>
                      </button>
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
        @if (!alreadySubmitted) {
          <div class="card-footer">
            <button class="btn btn-sm btn-primary" (click)="addOtherResponsibility()" title="Add other responsibility">
              <span class="material-icons">add</span>
            </button>
          </div>
        }
      </div>

      @if (!onBehalfOf && alreadySubmitted) {
        <p><strong>Acknowledgement and Confirmation by the Employee:</strong></p>
        <p>
          Name: {{ user?.name }}<br />
          Date: {{ declarationDate | date }}
        </p>
      }
    </form>
    <div class="btn-group">
      @if (alreadySubmitted) {
        <button class="btn btn-primary" disabled>YOU ALREADY SUBMITTED THIS DECLARATION</button>
      } @else {
        @if (!onBehalfOf) {
          <button class="btn btn-primary" [disabled]="!form.valid" (click)="submitForm()">SUBMIT</button>
        } @else {
          <button class="btn btn-primary" [disabled]="!form.valid" (click)="saveFormOnBehalOf()">SAVE</button>
        }
      }
      <button class="btn btn-secondary" (click)="location.back()">BACK</button>
    </div>
  </div>
</div>

<!-- Syncfusion Acknowledgement Dialog -->
<ejs-dialog #ackDialog [(visible)]="showAckDialog" width="600px" [isModal]="true">
  <ad-uk-statement-of-responsibilities-ack-dialog [data]="ackDialogData" (closeDialog)="handleDialogClose($event)">
  </ad-uk-statement-of-responsibilities-ack-dialog>
</ejs-dialog>
